let DATA_CONFIG = {}

export async function getConfig() {
    const res = await fetch('/config.json')
    const data = await res.json()
    DATA_CONFIG = data
}

const ENUM_ENV = {
    VUE_APP_REALM_KEYCLOAK: "[{'name':'keycloak-oidc-puri','realm':'bo-puri'},{'name':'keycloak-oidc-karawang','realm':'bo-karwawang'},{'name':'keycloak-oidc-mhg','realm':'bo-mhg'}]",
    VUE_APP_LIST_BACKOFFICE: "[{'name': 'Care Dokter Back Office', 'target': 'https://dbomsunew.cditdev.xyz'}, {'name': 'Internal Mandaya Royal Puri', 'target': 'http://dcaller.cd.local'}, {'name': 'Internal Mandaya Karawang', 'target': 'http://dcaller.cd.local'}]",
    VUE_APP_API_URL: "",
    VUE_APP_WEB_SOCKET: "",
    VUE_APP_WEB_MAXIMAL_SLOT: "",
    VUE_APP_PER_PAGE: "",
    VUE_APP_REGISTER_URL: "",
    VUE_APP_WEB_SOCKET_CHAT: "",
    VUE_APP_SSO_REALM: "",
    VUE_APP_SSO_LINK: "",
    VUE_APP_SSO_CLIENT_ID: "",
    VUE_APP_POST_PRINTER: "",
    VUE_APP_GET_PRINTER: "",
    VUE_APP_KEY_PRINTER: "",
    VUE_APP_SNAP_PAYMENT: "",
    VUE_APP_REALM_KEYCLOAK: "",
    VUE_APP_LIST_BACKOFFICE: "",
    VUE_APP_OTHER_BACKOFFICE: "",
    VUE_APP_CAREPLAN_GINJAL: ""
}

export const getDataConfig = () => {
    const VUE_APP_REALM_KEYCLOAK = DATA_CONFIG.VUE_APP_REALM_KEYCLOAK ?? ENUM_ENV.VUE_APP_REALM_KEYCLOAK
    const VUE_APP_LIST_BACKOFFICE = DATA_CONFIG.VUE_APP_LIST_BACKOFFICE ?? ENUM_ENV.VUE_APP_LIST_BACKOFFICE
    const VUE_APP_API_URL = DATA_CONFIG.VUE_APP_API_URL ?? ENUM_ENV.VUE_APP_API_URL
    const VUE_APP_WEB_SOCKET = DATA_CONFIG.VUE_APP_WEB_SOCKET ?? ENUM_ENV.VUE_APP_WEB_SOCKET
    const VUE_APP_WEB_MAXIMAL_SLOT = DATA_CONFIG.VUE_APP_WEB_MAXIMAL_SLOT ?? ENUM_ENV.VUE_APP_WEB_MAXIMAL_SLOT
    const VUE_APP_PER_PAGE = DATA_CONFIG.VUE_APP_PER_PAGE ?? ENUM_ENV.VUE_APP_PER_PAGE
    const VUE_APP_REGISTER_URL = DATA_CONFIG.VUE_APP_REGISTER_URL ?? ENUM_ENV.VUE_APP_REGISTER_URL
    const VUE_APP_WEB_SOCKET_CHAT = DATA_CONFIG.VUE_APP_WEB_SOCKET_CHAT ?? ENUM_ENV.VUE_APP_WEB_SOCKET_CHAT
    const VUE_APP_SSO_REALM = DATA_CONFIG.VUE_APP_SSO_REALM ?? ENUM_ENV.VUE_APP_SSO_REALM
    const VUE_APP_SSO_LINK = DATA_CONFIG.VUE_APP_SSO_LINK ?? ENUM_ENV.VUE_APP_SSO_LINK
    const VUE_APP_SSO_CLIENT_ID = DATA_CONFIG.VUE_APP_SSO_CLIENT_ID ?? ENUM_ENV.VUE_APP_SSO_CLIENT_ID
    const VUE_APP_POST_PRINTER = DATA_CONFIG.VUE_APP_POST_PRINTER ?? ENUM_ENV.VUE_APP_POST_PRINTER
    const VUE_APP_GET_PRINTER = DATA_CONFIG.VUE_APP_GET_PRINTER ?? ENUM_ENV.VUE_APP_GET_PRINTER
    const VUE_APP_KEY_PRINTER = DATA_CONFIG.VUE_APP_KEY_PRINTER ?? ENUM_ENV.VUE_APP_KEY_PRINTER
    const VUE_APP_SNAP_PAYMENT = DATA_CONFIG.VUE_APP_SNAP_PAYMENT ?? ENUM_ENV.VUE_APP_SNAP_PAYMENT
    const VUE_APP_OTHER_BACKOFFICE = DATA_CONFIG.VUE_APP_OTHER_BACKOFFICE ?? ENUM_ENV.VUE_APP_OTHER_BACKOFFICE
    const VUE_APP_CAREPLAN_GINJAL = DATA_CONFIG.VUE_APP_CAREPLAN_GINJAL ?? ENUM_ENV.VUE_APP_CAREPLAN_GINJAL
    return {
        VUE_APP_LIST_BACKOFFICE,
        VUE_APP_REALM_KEYCLOAK,
        VUE_APP_API_URL,
        VUE_APP_WEB_SOCKET,
        VUE_APP_WEB_MAXIMAL_SLOT,
        VUE_APP_PER_PAGE,
        VUE_APP_REGISTER_URL,
        VUE_APP_WEB_SOCKET_CHAT,
        VUE_APP_SSO_REALM,
        VUE_APP_SSO_LINK,
        VUE_APP_SSO_CLIENT_ID,
        VUE_APP_POST_PRINTER,
        VUE_APP_GET_PRINTER,
        VUE_APP_KEY_PRINTER,
        VUE_APP_SNAP_PAYMENT,
        VUE_APP_OTHER_BACKOFFICE,
        VUE_APP_CAREPLAN_GINJAL
    }
}